import { ca } from '@cian/analytics';

export function trackPushNotificationEnable() {
  ca('event', {
    action: 'Send',
    category: 'subscription',
    label: 'From_cat_ChangePrice_first/PushOn',
  });
}
